import React, { Component } from 'react';
import '../styles/Sidebar.css';

class SidebarProvincial extends Component
{
	constructor(props) {
		super(props);
		this.state = {
			accountType: props.type
		};
		this.handleButtonChange = this.handleButtonChange.bind(this);
	}

	handleButtonChange(event) {
		console.log('handleButtonChange')
		this.props.onMenuItemClick(event.target.value);
	}

	render() {
		return(<div className="sidebar" onChange={this.handleButtonChange}>
			{/* <input type="radio" name="buttons" className="radios rad-item" id="dashboard-btn" value="dashboard" defaultChecked={true} />
			<label className="button" htmlFor="dashboard-btn">DASHBOARD</label> */}
			<input type="radio" name="buttons" className="radios rad-item" id="site-btn" value="sites" />
			<input type="radio" name="buttons" className="radios rad-item" id="reports-btn" value="reports" />
			<label className="button" htmlFor="reports-btn">REPORTS</label>
			<Clock />
		</div>);
	}
}

class Clock extends Component
{
	constructor(props) {
		super(props);
		this.state = {
			date: setTimeZone(8)
		};
	}

	componentDidMount() {
		const cMonth = this.state.date.getMonth() + 1;
		const cDay = this.state.date.getDate();
		const cYear = this.state.date.getFullYear();
		const cDate = cMonth + "/" + cDay + "/" + cYear;
		this.setState({cDate: cDate});
		this.timerID = setInterval(() => this.tick(), 1000);
	}

	componentWillUnmount() {
		clearInterval(this.timerID);
	}

	tick() {
		const date = new Date(this.state.date.setSeconds(this.state.date.getSeconds() + 1));
		this.setState({date: date});
	}

	render() {
		return(
			<div id="clock">
				<div id="clock-date">{this.state.cDate}</div>
				<div id="clock-time">{this.state.date.toLocaleTimeString()}</div>
			</div>
		);
	}
}

const setTimeZone = (offset) => {
	const date = new Date();
	const localeOffset = date.getTimezoneOffset() * 60000;
	const utc = date.getTime() + localeOffset;
	const nLocale = utc + (3600000 * offset);
	return(new Date(nLocale));
}

export default SidebarProvincial;
